import { useFlags } from 'launchdarkly-react-client-sdk';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AdminDashboardCharts from '../AdminDashboardCharts/AdminDashboardCharts';
import AdminDashboardFilters from '../AdminDashboardFilters/AdminDashboardFilters';
import useAdminDashboardFilters from '../AdminDashboardFilters/AdminDashboardFilters.hook';
import {
  adminDashboardChartsLoaderStyle,
  adminDashboardGridListStyle,
  adminDashboardSummaryStatsStyle,
  adminDashboardSummaryTitleStyle,
  adminDashboardTitleStyle,
} from './AdminDashboard.style';
import CepAdminDashBoardList from './CepAdminDashboardGridlist/CepAdminDashboardList';
import CiAdminDashboardList from './CiAdminDashboardGridlist/CiAdminDashboardList';
import ContentCard from 'components/ContentCard';
import CountCepWidget from 'components/CountWidgets/CountCepWidget/CountCepWidget';
import CountCiWidget from 'components/CountWidgets/CountCiWidget/CountCiWidget';
import CountTacticsWidget from 'components/CountWidgets/CountTacticsWidget/CountTacticsWidget';
import CountTargetsWidget from 'components/CountWidgets/CountTargetsWidget/CountTargetsWidget';
import TargetsEngagementWidget from 'components/CountWidgets/TargetsEngagementWidget/TargetsEngagementWidget';
import TargetsReachWidget from 'components/CountWidgets/TargetsReachWidget/TargetsReachWidget';
import Box from 'yoda-ui/components/Box';
import Loader from 'yoda-ui/components/Loader';

const AdminDashboard: FC = () => {
  const { t } = useTranslation();
  const flags = useFlags();
  const {
    providerFields,
    adminDashboardFiltersConfig,
    exportDataButtonConfig,
    exportChartsButtonConfig,
    filters,
    products,
    chartsRef,
    triggerExportCharts,
    selectedFilters,
    handleFilterChange,
    handleRemoveChip,
    hasSelectedFilters,
    handleReset,
    handleSearchValueOfUserFilters,
  } = useAdminDashboardFilters();

  return (
    <Box flexDirection="column">
      <Box sx={ adminDashboardTitleStyle }>
        { t('maya_dashboard_title') }
      </Box>

      <AdminDashboardFilters
        providerFields={ providerFields }
        adminDashboardFiltersConfig={ adminDashboardFiltersConfig }
        exportDataButtonConfig={ exportDataButtonConfig }
        exportChartsButtonConfig={ exportChartsButtonConfig }
        handleSearchValueOfUserFilters={ handleSearchValueOfUserFilters }
        selectedFilters={ selectedFilters }
        handleFilterChange={ handleFilterChange }
        handleRemoveChip={ handleRemoveChip }
        hasSelectedFilters={ hasSelectedFilters }
        handleReset={ handleReset }
      />

      <Box>
        <ContentCard>
          <Box sx={ adminDashboardSummaryTitleStyle }>
            { t('maya_dashboard_title_summary_stats_title') }
          </Box>

          <Box sx={ adminDashboardSummaryStatsStyle }>
            <CountCiWidget filters={ filters } useAdminFilters={ true } />
            <CountCepWidget filters={ filters } useAdminFilters={ true } />
            <CountTacticsWidget filters={ filters } useAdminFilters={ true } />
            <CountTargetsWidget filters={ filters } useAdminFilters={ true } />
            <TargetsEngagementWidget filters={ filters } useAdminFilters={ true } />
            <TargetsReachWidget filters={ filters } useAdminFilters={ true } />
          </Box>
        </ContentCard>

        {
          flags.mayaAkma230EnableChartsOnDashboardPage
          && products.length
            ? <AdminDashboardCharts filters={ filters } chartsRef={ chartsRef } triggerExportCharts={ triggerExportCharts }/>
            : <Box sx={ adminDashboardChartsLoaderStyle }><Loader center /></Box>
        }

        <Box sx={ adminDashboardGridListStyle }>
          <CiAdminDashboardList filters={ filters } useAdminFilters={ true } />
          <CepAdminDashBoardList filters={ filters } useAdminFilters={ true } />
        </Box>
      </Box>
    </Box>
  );
};

export default AdminDashboard;
